import mixins from 'vue-typed-mixins';

import { ModalData } from '@/interfaces/EventBusData';
import { eventBus } from '@/services/event-bus';

export const dynamicModal = mixins().extend({
	methods: {
		openDynamicModal(config: ModalData): void {
			eventBus.$emit('open-modal', config);
		}
	},
});
